<template>
  <v-container id="permission-list" class="permissions-list-root overflow-y-auto">
    <v-row v-for="(feature, index) in features" :key="index">
      <v-row class="permissions-feature level-0">
        <v-col class="feature-name">
          <button
            v-if="feature.children && feature.children.length && isExpanded(feature.name)"
            :id="`${feature.name}-expander`"
            class="expander"
            @click="unexpand(feature.name)"
          >
            <v-icon>
              mdi-chevron-down
            </v-icon>
          </button>
          <button
            v-else-if="feature.children && feature.children.length
              && !isExpanded(feature.name)"
            :id="`${feature.name}-expander`"
            class="expander"
            @click="expand(feature.name)"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </button>
          <span v-else class="expander">&nbsp;</span>
          <strong :id="feature.name" class="names">
            {{ $t(`access.user_role.permissions.labels.${feature.name}`) }}
          </strong>
        </v-col>
        <v-col v-if="feature.children.length == 0" class="col-md-8 feature-permissions usual">
          <div class="read-actions">
            <v-btn
              v-if="!feature.children.length
                && feature.data && feature.data.read !== undefined"
              :id="`${feature.name}-read-all`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              :class="buttonClass(feature.data.read, 'read')"
              @click="feature.data = updateRead(feature)"
            >
              {{ $t('access.user_role.permissions.rights.read') }}
            </v-btn>
            <span v-else class="unknow read"> - </span>
          </div>
          <div class="write-actions">
            <v-btn
              v-if="!feature.children.length
                && feature.data && feature.data.write !== undefined"
              :id="`${feature.name}-write`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              :class="buttonClass(feature.data.write, 'write')"
              @click="feature.data = updateWrite(feature)"
            >
              {{ $t('access.user_role.permissions.rights.write') }}
            </v-btn>
            <span v-else class="unknow write"> - </span>
          </div>
        </v-col>
        <v-col v-else class="col-md-8 feature-permissions usual">
          <div class="read-actions">
            <v-btn
              v-if="check(feature.name, 'read') !== undefined"
              :id="`${feature.name}-read-all`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              :class="buttonClass(check(feature.name, 'read'), 'read')"
              @click="updateChildren(feature.name, 'read',
                                     !check(feature.name, 'read'))"
            >
              {{ $t('access.user_role.permissions.rights.read_all') }}
            </v-btn>
            <v-btn
              v-else
              :id="`${feature.name}-read-all-unknow`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              class="unknow read"
              @click="updateChildren(feature.name, 'read', true)"
            >
              -
            </v-btn>
          </div>
          <div class="write-actions">
            <v-btn
              v-if="check(feature.name, 'write') !== undefined"
              :id="`${feature.name}-write-all`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              :class="buttonClass(check(feature.name, 'write'), 'write')"
              @click="updateChildren(feature.name, 'write',
                                     !check(feature.name, 'write'))"
            >
              {{ $t('access.user_role.permissions.rights.write_all') }}
            </v-btn>
            <v-btn
              v-else-if="checkChildren(features.value, feature.name, 'write', false).length > 1"
              :id="`${feature.name}-write-all-unknow`"
              :disabled="!getEdition && !props.edition"
              raised
              outlined
              x-small
              class="unknow write"
              @click="updateChildren(feature.name, 'write', true)"
            >
              -
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-container v-if="feature.children && isExpanded(feature.name)" class="children">
        <v-row v-for="(subfeature, subindex) in feature.children" :key="subindex">
          <v-row class="permissions-feature level-1">
            <v-col class="feature-name">
              <button
                v-if="subfeature.children.length && !isExpanded(subfeature.name)"
                :id="`${subfeature.name}-expander`"
                class="expander"
                @click="expand(subfeature.name)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </button>
              <button
                v-else-if="subfeature.children.length && isExpanded(subfeature.name)"
                :id="`${subfeature.name}-expander`"
                class="expander"
                @click="unexpand(subfeature.name)"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </button>
              <span v-else class="expander">&nbsp;</span>
              <strong :id="subfeature.name" class="names">
                {{ $t(`access.user_role.permissions.labels.${subfeature.name}`) }}
              </strong>
            </v-col>
            <v-col
              v-if="!subfeature.children.length"
              class="col-md-8 feature-permissions usual"
            >
              <div class="read-actions">
                <v-btn
                  v-if="subfeature.data && subfeature.data.read !== undefined"
                  :id="`${subfeature.name}-read`"
                  :disabled="(!getEdition && !props.edition) || subfeature.id === 'User Role Management' || subfeature.id === 'Master Management'"
                  raised
                  outlined
                  x-small
                  :class="buttonClass(subfeature.data.read, 'read')"
                  @click="subfeature.data = updateRead(subfeature)"
                >
                  {{ $t('access.user_role.permissions.rights.read') }}
                </v-btn>
                <span v-else class="unknow read"> - </span>
              </div>
              <div class="write-actions">
                <v-btn
                  v-if="subfeature.data && subfeature.data.write !== undefined"
                  :id="`${subfeature.name}-write`"
                  :disabled="!getEdition && !props.edition"
                  raised
                  outlined
                  x-small
                  :class="buttonClass(subfeature.data.write, 'write')"
                  @click="subfeature.data = updateWrite(subfeature)"
                >
                  {{ $t('access.user_role.permissions.rights.write') }}
                </v-btn>
                <span v-else class="unknow write"> - </span>
              </div>
            </v-col>
            <v-col v-else class="col-md-8 feature-permissions usual">
              <div class="read-actions">
                <v-btn
                  v-if="check(subfeature.name, 'read') !== undefined"
                  :id="`${subfeature.name}-read-all`"
                  :disabled="!getEdition && !props.edition"
                  raised
                  outlined
                  x-small
                  :class="buttonClass(check(subfeature.name, 'read'), 'read')"
                  @click="updateChildren(subfeature.name, 'read', !check(subfeature.name, 'read'))"
                >
                  {{ $t('access.user_role.permissions.rights.read_all') }}
                </v-btn>
                <v-btn
                  v-else
                  :id="`${subfeature.name}-read-all-unknow`"
                  :disabled="!getEdition && !props.edition"
                  raised
                  outlined
                  x-small
                  class="unknow read"
                  @click="updateChildren(subfeature.name, 'read', true)"
                >
                  -
                </v-btn>
              </div>
              <div class="write-actions">
                <v-btn
                  v-if="check(subfeature.name, 'write') !== undefined"
                  :id="`${subfeature.name}-write-all`"
                  :disabled="!getEdition && !props.edition"
                  raised
                  outlined
                  x-small
                  :class="buttonClass(check(subfeature.name, 'write'), 'write')"
                  @click="updateChildren(subfeature.name, 'write', !check(subfeature.name, 'write'))"
                >
                  {{ $t('access.user_role.permissions.rights.write_all') }}
                </v-btn>
                <v-btn
                  v-else
                  :id="`${subfeature.name}-write-all-unknow`"
                  :disabled="!getEdition && !props.edition"
                  raised
                  outlined
                  x-small
                  class="unknow write"
                  @click="updateChildren(subfeature.name, 'write', true)"
                >
                  -
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-container v-if="subfeature.children && isExpanded(subfeature.name)" class="children">
            <v-row v-for="(subsubfeature, subsubindex) in subfeature.children" :key="subsubindex">
              <v-row class="permissions-feature level-2">
                <v-col class="feature-name">
                  <v-icon v-if="subsubfeature.children.length" class="expander">
                    mdi-chevron-down
                  </v-icon>
                  <span v-else class="expander">&nbsp;</span>
                  <strong :id="subsubfeature.name" class="names">
                    {{ $t(`access.user_role.permissions.labels.${subsubfeature.name}`) }}
                  </strong>
                </v-col>
                <v-col class="col-md-8 feature-permissions usual">
                  <div class="read-actions">
                    <v-btn
                      v-if="subsubfeature.data && subsubfeature.data.read !== undefined"
                      :id="`${subsubfeature.name}-read`"
                      :disabled="!getEdition && !props.edition"
                      raised
                      outlined
                      x-small
                      :class="buttonClass(subsubfeature.data.read, 'read')"
                      @click="subsubfeature.data = updateRead(subsubfeature)"
                    >
                      {{ $t('access.user_role.permissions.rights.read') }}
                    </v-btn>
                    <span v-else class="unknow read"> - </span>
                  </div>
                  <div class="write-actions">
                    <v-btn
                      v-if="subsubfeature.data && subsubfeature.data.write !== undefined"
                      :id="`${subsubfeature.name}-write`"
                      :disabled="!getEdition && !props.edition"
                      raised
                      outlined
                      x-small
                      :class="buttonClass(subsubfeature.data.write, 'write')"
                      @click="subsubfeature.data = updateWrite(subsubfeature)"
                    >
                      {{ $t('access.user_role.permissions.rights.write') }}
                    </v-btn>
                    <span v-else class="unknow write"> - </span>
                  </div>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { IPermissionsFeatures, UserRole } from '@/store/modules/userRoles/types';
import useStore from '@/utils/store/common';
import { computed, onMounted, ref, watch } from 'vue';
import { buildPathOfPermissions,
  checkRightsAllChildren,
  permissionsListOfTree,
  reducePathOfPermissions,
  reduceTreeOfPermissions,
  updateAllChildren,
  updateTree } from './utils';
import './styles/permissions-list.scss';

const props = defineProps({
  permissions:
  {
    type: Array,
    default: () => ([] as IPermissionsFeatures[])
  },

  role:
  {
    type: Object,
    default: () => ({} as UserRole)
  },
  edition:
  {
    type: Boolean
  },
  reload:
  {
    type: Boolean
  }
});

const emit = defineEmits(['draftUpdated', 'reloaded']);

const store = useStore();

const expanded = ref(['Access Management', 'Device Management', 'Tolling']);

const checkChildren = checkRightsAllChildren;

const features = ref([] as any[]);

const getEdition = computed(() => store.getters['userRoles/getEdition']);

function initFeatures() {
  const allPaths = buildPathOfPermissions(props.permissions);
  const reducedPaths = reducePathOfPermissions(allPaths);
  const reducedTree = reduceTreeOfPermissions(reducedPaths);
  features.value = reducedTree;
}

onMounted(async () => {
  await store.dispatch('userRoles/fetchPermissionsFeatures');
  initFeatures();
});

function isExpanded(featureName: string) {
  return expanded.value.includes(featureName);
}

function expand(featureName: string) {
  if (!isExpanded(featureName)) {
    expanded.value.push(featureName);
  }
}

function unexpand(featureName: string) {
  if (isExpanded(featureName)) {
    expanded.value = expanded.value.filter(name => name !== featureName);
  }
}

function buttonClass(right: boolean, rightName: string) {
  return (right ? `${rightName} rights set` : `${rightName} rights notset`);
}

function check(permission: string, right: string) {
  const result = checkRightsAllChildren(features.value, permission, right, false);
  return result.length !== 1 ? undefined : result[0];
}

function updateChildren(permission: string, right: string, value: boolean) {
  features.value = updateAllChildren(features.value, permission, right, value, false);
  if (right === 'write' && value) {
    features.value = updateAllChildren(features.value, permission, 'read', value, false);
  } else if (right === 'read' && !value) {
    features.value = updateAllChildren(features.value, permission, 'write', value, false);
  }
}

function updateWrite(feature: any) {
  const editedFeature = feature;
  editedFeature.data.write = !feature.data.write;
  if (feature.data.read) {
    editedFeature.data.read = feature.data.read || feature.data.write;
  }
  return editedFeature.data;
}

function updateRead(feature: any) {
  const editedFeature = feature;
  editedFeature.data.read = !feature.data.read;
  editedFeature.data.write = feature.data.write && feature.data.read;
  return editedFeature.data;
}

async function onRoleChange() {
  await store.dispatch('userRoles/fetchPermissionsFeatures');
  initFeatures();
  const rolePermissions = store.getters['userRoles/getPermissionsFeaturesOfCurrentlySelectedUserRole'];
  if (rolePermissions) {
    _.each(rolePermissions, (permission: any) => {
      features.value = updateTree(features.value, permission);
    });
    emit('draftUpdated', permissionsListOfTree(features.value));
  }
}

watch(
  () => props.role,
  () => onRoleChange(),
  {
    immediate: true,
    deep: true
  }
);

watch(
  () => props.reload,
  () => {
    onRoleChange();
    emit('reloaded');
  },
  {
    immediate: true
  }
);

watch(
  () => features.value,
  () => {
    if (props.edition) {
      emit('draftUpdated', permissionsListOfTree(features.value));
    }
  },
  {
    immediate: true,
    deep: true
  }
);
</script>
